import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { Component, Input } from "@angular/core";
import { AccountantService } from "../../../../accountant/accountant.service";
import { ConfirmationModalComponent } from "../../../modals/confirmation-modal.component";
import { HotToastService } from "@ngneat/hot-toast";
import { JobsService } from "../../jobs.service";
import { TagComponent } from "../../../../common/tags/tag.component";
import { NgIf, NgFor } from "@angular/common";

@Component({
    selector: "job-bulk-edit-tags-modal",
    templateUrl: "./bulk-edit-tags-modal.component.html",
    styleUrls: ["./bulk-edit-tags-modal.component.scss"],
    imports: [NgIf, NgFor, TagComponent]
})
export class BulkEditTagsModalComponent implements OnInit {
  loading: boolean = false;
  @Input() jobs: any[] = [];
  @Input() action: "add" | "remove";
  @Input() tags: any[] = [];

  selectedTags: any[] = [];

  public onClose: Subject<boolean>;

  public constructor(
    private accountantService: AccountantService,
    private toastr: HotToastService,
    private jobsService: JobsService,
    public modalService: BsModalService,
    public bsModalRef: BsModalRef
  ) {}

  ngOnInit() {
    this.accountantService.getAccountingCompanyTags().then((res: any) => {
      this.tags = res;

      // this.filterExistingTags();
    });
    this.onClose = new Subject();
  }

  addToSelection(tag: any) {
    this.selectedTags.push(tag);
  }

  removeFromSelection(tag: any) {
    this.selectedTags.splice(this.selectedTags.findIndex(tag), 1);
  }

  confirm() {
    if (this.selectedTags.length === 0) {
      return;
    }
    this.bsModalRef.hide();
    let initialState = {
      message: `These ${this.jobs.length} jobs will have ${
        this.selectedTags.length
      } tags ${this.action === "add" ? "added" : "removed"}.<br/> \
                If there are many jobs selected, this may take some time to complete.<br/> \
                Continue?`,
      confirmButtonClass: "btn-primary",
    };
    let confirmationModal = this.modalService.show(ConfirmationModalComponent, {
      initialState,
    });
    confirmationModal.content.onClose.subscribe((res) => {
      if (res) {
        this.manageTags();
        this.onClose.next(true);
      }
    });
  }

  manageTags() {
    this.loading = true;
    this.jobsService
      .manageTags(
        this.action,
        this.jobs.map((j) => j.uuid),
        this.selectedTags.map((t) => t.uuid)
      )
      .then((res) => {
        this.toastr.success("The jobs will be updated soon.");
        this.onClose.next(true);
      })
      .catch((err) => {
        this.toastr.error("Failed to update the tags of the selected jobs.");
      })
      .finally(() => (this.loading = false));
  }

  cancel() {
    this.bsModalRef.hide();
    this.onClose.next(false);
  }
}
